function copyTextWithExec(text: string) {
  if (!document.execCommand) {
    throw new Error('execCommand is not supported');
  }

  const textArea = document.createElement('textarea');

  Object.assign(textArea.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '2em',
    height: '2em',
    padding: '0',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    background: 'transparent'
  });

  textArea.value = text;

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');

    if (!successful) {
      throw new Error('execCommand is not supported');
    }
  } finally {
    document.body.removeChild(textArea);
  }
}

async function copyTextWithNavigator(text: string) {
  if (!navigator.clipboard || !navigator.permissions) {
    throw new Error('Clipboard API is not supported');
  }

  const permission = await navigator.permissions.query({
    name: 'clipboard-write' as PermissionName
  });

  if (permission.state === 'granted') {
    await navigator.clipboard.writeText(text);
  } else {
    throw new Error('Clipboard API is denied');
  }
}

export async function copyTextToClipboard(text: string) {
  try {
    try {
      await copyTextWithNavigator(text);
    } catch {
      copyTextWithExec(text);
    }
  } catch (e) {
    console.log(`Oops, unable to copy "${text}"`, e);
  }
}
